import React from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { useTheme } from '../../context/ThemeContext';

const SocialMediaManagement: React.FC = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const posts = [
    { id: 1, platform: 'Twitter', content: 'Launching our new feature today! 🚀', status: 'scheduled', date: '2025-08-20 10:00' },
    { id: 2, platform: 'Instagram', content: 'Behind the scenes with our team 👀', status: 'draft', date: '-' },
    { id: 3, platform: 'LinkedIn', content: 'We are hiring a Senior Engineer!', status: 'published', date: '2025-08-18 14:30' },
  ];

  const statusVariant = (s: string) => s === 'published' ? 'success' : s === 'scheduled' ? 'info' : 'secondary';

  return (
    <Container fluid className="py-4">
      <style>{`
        .sm-title { color: ${isDark ? '#e2e8f0' : '#111827'}; }
        .sm-card { background: ${isDark ? '#1f2937' : '#ffffff'}; border: 1px solid ${isDark ? '#334155' : '#e9ecef'}; box-shadow: ${isDark ? '0 4px 16px rgba(0,0,0,0.5)' : '0 2px 8px rgba(0,0,0,0.08)'}; }
        .sm-subtle { color: ${isDark ? '#94a3b8' : '#6b7280'}; }
      `}</style>

      <Row className="mb-4 align-items-center">
        <Col>
          <h2 className="fw-bold sm-title">Social Media</h2>
        </Col>
        <Col xs="auto">
          <Button variant="primary">Create Post</Button>
        </Col>
      </Row>

      <Row className="g-4">
        {posts.map(p => (
          <Col md={6} lg={4} key={p.id}>
            <Card className="sm-card h-100">
              <Card.Body>
                <div className="d-flex justify-content-between mb-2">
                  <h5 className="mb-0">{p.platform}</h5>
                  <Badge bg={statusVariant(p.status)}>{p.status}</Badge>
                </div>
                <p className="mb-3">{p.content}</p>
                <div className="d-flex justify-content-between align-items-center">
                  <small className="sm-subtle">{p.date}</small>
                  <div className="d-flex gap-2">
                    <Button size="sm" variant="outline-primary">Edit</Button>
                    <Button size="sm" variant="outline-secondary">Preview</Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default SocialMediaManagement;